import React, { useCallback } from "react";

/**
 * Lightweight masked input that avoids findDOMNode (react-input-mask uses it).
 * Supports mask="99999" (zipcode) and mask="(999) 999-9999" (US phone).
 */
function formatWithMask(value, mask) {
  const digits = (value || "").replace(/\D/g, "").split("");
  if (mask === "99999") {
    return digits.slice(0, 5).join("");
  }
  if (mask === "(999) 999-9999") {
    const d = digits.slice(0, 10);
    if (d.length === 0) return "";
    if (d.length <= 3) return "(" + d.join("");
    if (d.length <= 6) return "(" + d.slice(0, 3).join("") + ") " + d.slice(3).join("");
    return "(" + d.slice(0, 3).join("") + ") " + d.slice(3, 6).join("") + "-" + d.slice(6).join("");
  }
  return value;
}

function MaskedInput({ mask, value, onChange, onBlur, name, ...rest }) {
  const displayValue = mask ? formatWithMask(value, mask) : value;

  const handleChange = useCallback(
    (e) => {
      const raw = e.target.value;
      const formatted = mask ? formatWithMask(raw, mask) : raw;
      if (onChange) {
        const synthetic = { target: { name, value: formatted } };
        onChange(synthetic);
      }
    },
    [mask, name, onChange]
  );

  return (
    <input
      {...rest}
      name={name}
      value={displayValue}
      onChange={handleChange}
      onBlur={onBlur}
      type="text"
      inputMode={mask === "99999" ? "numeric" : "tel"}
      autoComplete={mask === "(999) 999-9999" ? "tel" : undefined}
    />
  );
}

export default MaskedInput;
